export const profileVisibilities = [
  {
    key: 'public',
    title: 'Public',
    description: 'Visible to all visitors and may appear in search engine results.',
  },
  { key: 'private', title: 'Private', description: 'Visible to only active Startups.com Members.' },
  { key: 'hidden', title: 'Hidden', description: 'Visible to only you.' },
].map(x => ({ ...x, id: x.key }))
